export type MicrophoneAccessResult = "granted" | "denied" | "unavailable";

/**
 * Prompts for microphone access and immediately releases the stream.
 */
export const requestMicrophoneAccess =
  async (): Promise<MicrophoneAccessResult> => {
    if (
      typeof navigator === "undefined" ||
      !navigator.mediaDevices?.getUserMedia
    ) {
      return "unavailable";
    }

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      });

      stream.getTracks().forEach((track) => {
        track.stop();
      });

      return "granted";
    } catch (error: unknown) {
      if (isMicrophonePermissionDeniedError(error)) {
        return "denied";
      }

      return "unavailable";
    }
  };

/**
 * Returns true when a getUserMedia rejection means the user blocked microphone access.
 */
export const isMicrophonePermissionDeniedError = (error: unknown): boolean => {
  if (!(error instanceof DOMException)) {
    return false;
  }

  return (
    error.name === "NotAllowedError" || error.name === "PermissionDeniedError"
  );
};
